export interface ProjectTransitiveDependency {
  dependencyCount: number;
  sfdcProjectId: string;
}

export interface ProjectDependency {
  projectDependency: ProjectTransitiveDependency[];
}
